import { EmailGroupEnum } from 'types/email';
import { FundriseRouteConfig } from 'vue-router';
import { useLazyEmailStore } from '@stores/index';

const emailUnsubscribeRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/email/iterable-unsubscribe/:unsubscribeKey/message-type/:messageTypeId',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: (route) => ({
			name: 'email-unsubscribe',
			query: { ...route.params },
			replace: true
		})
	},
	{
		path: '/email/nonUserUnsubscribe',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		name: 'non-user-unsubscribe',
		redirect: { name: 'email-unsubscribe' }
	},
	{
		path: '/email/unsubscribe',
		name: 'email-unsubscribe',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/email/one-click-unsubscribe.vue'),
		beforeEnter: async (to) => {
			const emailStore = await useLazyEmailStore();
			if (emailStore.unsubscribeKey) return;

			try {
				const {
					path,
					query: { unsubscribeKey, messageTypeId, emailGroup }
				} = to;

				await emailStore.getEmailGroupSubscriptions(unsubscribeKey as string);

				if (messageTypeId) {
					await emailStore.oneClickUnsubscribeIterable(messageTypeId as string);
				}
				if (emailGroup) {
					await emailStore.oneClickUnsubscribeEmailGroup(emailGroup as EmailGroupEnum);
				}

				return { path, query: { unsubscribeKey }, replace: true };
			} catch (error) {
				return '404';
			}
		}
	}
];

export default emailUnsubscribeRoutes;
